module.exports = __webpack_public_path__ + "static/img/95568.41d05f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/95568.png
// module id = U/4p
// module chunks = 18